import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);


// layout路由1
const routerPage = {
  path: '/layout',
  name: 'layout',
  redirect: '/home',
  component: () =>
    import('@/views/layout/index.vue'),
  children: [{
    path: '/home',
    name: 'home',
    meta: {
      title: '智能审批、合同对比，让企业合同管理提效率、降风险'
    },
    component: () =>
      import('@/views/home/index.vue')
  },
  {
    path: '/scene',
    name: 'scene',
    meta: {
      title: '提效率、降风险，全生命周期合同管理，做最好用的合同管理'
    },
    component: () =>
      import('@/views/scene/index.vue')
  },
  {
    path: '/case',
    name: 'case',
    meta: {
      title: '范本管理是降低合同风险最有效的手段，吉智提供极致范本管控'
    },
    component: () =>
      import('@/views/case/index.vue')
  },
  {
    path: '/about',
    name: 'about',
    meta: {
      title: '深度集成，赋能企业，提升各业务系统合同管理能力'
    },
    component: () =>
      import('@/views/about/index.vue')
  },

  ]
};


const routes = [
  routerPage,
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/test',
    name: 'test',
    component: () =>
      import('@/views/test.vue')
  },

  {
    path: '*', // 从上往下找 不存在时
    redirect: '/home'
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

//连续点击多次路由报错解决方法
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


export default router